import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { BelegEntry } from '../../../core/gb-api';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { DokulinkItemBuilderFactory } from '../../components/dokulink/dokulinkItemBuilderFactory';
import { BelegAltReferenzObjektTyp, DokulinkItem } from '../../components/dokulink/dokulinkItem';
import { HistoryDirective } from '../../directives/history.directive';
import { LinkComponent } from '../../components/link/link.component';
import { DokulinkComponent } from '../../components/dokulink/dokulink.component';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { FormatBelegPipe } from '../../pipes/format/format-beleg.pipe';
import { BelegAltDokuLinkItemBuilder, BelegOhneGeschaeftDokuLinkItemBuilder } from '../../components/dokulink/dokulinkItemBuilder';
import { CmisDocumentTarget } from '../../components/cmis/cmis.service';
import { CmisComponent } from '../../components/cmis/cmis.component';

@Component({
  selector: 'cap-kompakt-beleg[referenzObjectId][referenzObjectType]',
  templateUrl: './kompakt-beleg.component.html',
  styleUrls: ['./kompakt-beleg.component.scss'],
  imports: [NgTemplateOutlet, HistoryDirective, LinkComponent, DokulinkComponent, CmisComponent, DatumPipe, FormatBelegPipe]
})
export class KompaktBelegComponent extends KompaktdarstellungTemplateComponent implements OnInit, OnDestroy {
  private _item: BelegEntry;
  @Input()
  set item(value: BelegEntry) {
    this._item = value;
    this.updateItemDependentState();
  }

  get item(): BelegEntry {
    return this._item;
  }

  @Input() histInfo;
  @Input() char = '';
  @Input() mitDatum = true;
  @Input() openInNewTab = false;
  @Input() enableNavigation = true;
  @Input() referenzObjectId: string;
  @Input() referenzObjectType: BelegAltReferenzObjektTyp;
  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;
  @ViewChild('typ03', { static: true }) typ03Template: TemplateRef<any>;
  existingGeschaeft = false;
  isDokuLinkGeschaeftConfigured = false;
  isCmisGeschaeftConfigured = false;
  protected cmisTarget: CmisDocumentTarget;
  protected dokulinkItem: DokulinkItem;

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    private appformatConfigService: FormatConfigService,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    private formatBeleg: FormatBelegPipe
  ) {
    super(formatService, 'BELEG', location, locationStrategy);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.isDokuLinkGeschaeftConfigured = config?.isDokuLinkGeschaeftConfigured;
        this.isCmisGeschaeftConfigured = config?.isCmisConfigured;
      })
    );
    this.updateItemDependentState();
  }

  private updateItemDependentState() {
    this.existingGeschaeft = this.item?.geschaeftId !== undefined;
    this.dokulinkItem = this.getDokulinkItem();
    this.cmisTarget = this.getCmisDocumentTarget();
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'BELEG_TYP00');
    this.bindTemplates(this.typ01Template, 'BELEG_TYP01');
    this.bindTemplates(this.typ02Template, 'BELEG_TYP02');
    this.bindTemplates(this.typ03Template, 'BELEG_TYP03');
  }

  private getCmisDocumentTarget(): CmisDocumentTarget {
    if (this.item.geschaeftId && !this.item.alt) {
      return {
        itemType: 'Geschaeft',
        id: this.item.geschaeftId.id,
        tooltipParam: this.formatBeleg.transform(this.item)
      };
    } else {
      return null;
    }
  }

  private getDokulinkItem(): DokulinkItem {
    if (this.item.alt) {
      return (<BelegAltDokuLinkItemBuilder>this.dokuLinkBuilderFactory.create('BELEG_ALT'))
        .setBelegAltEntry(this.item, this.referenzObjectId, this.referenzObjectType)
        .build();
    } else {
      if (this.item.geschaeftId) {
        return this.dokuLinkBuilderFactory.create('BELEG').setEntry(this.item).build();
      } else {
        return (<BelegOhneGeschaeftDokuLinkItemBuilder>this.dokuLinkBuilderFactory.create('BELEG_OHNE_GESCHAEFT'))
          .setBelegOhneGeschaeftEntry(this.item, this.referenzObjectId, this.referenzObjectType)
          .build();
      }
    }
  }
}
